import axios from 'axios';
import { getItem } from '../../utility/localStorageControl';
import { message } from 'antd';

const API_ENDPOINT = `${process.env.REACT_APP_API_ENDPOINT}/api`;

const authHeader = () => ({
  Authorization: `Bearer ${getItem('access_token')}`,
});

const client = axios.create({
  baseURL: API_ENDPOINT,
  withCredentials: true,
  headers: {
    Authorization: `Bearer ${getItem('access_token')}`,
    'Content-Type': 'application/json',
  },
});

class DataService {
  static get(path = '', params = {}, headers = {}, config = {}) {
    return client({
      method: 'GET',
      url: path,
      params,
      headers: { ...headers, ...authHeader() },
      ...config
    });
  }

  static delete(path = '') {
    return client({
      method: 'DELETE',
      url: path,
      headers: { ...authHeader() },
    });
  }

  static post(path = '', data = {}, optionalHeader = {}) {
    return client({
      method: 'POST',
      url: path,
      data,
      headers: { ...authHeader(), ...optionalHeader },
    });
  }

  static patch(path = '', data = {}) {
    return client({
      method: 'PATCH',
      url: path,
      data: JSON.stringify(data),
      headers: { ...authHeader() },
    });
  }

  static put(path = '', data = {}) {
    return client({
      method: 'PUT',
      url: path,
      data: JSON.stringify(data),
      headers: { ...authHeader() },
    });
  }

  static request(method, ...args) {
    switch (method.toLowerCase()) {
      case 'get':
        return this.get(...args);
      case 'post':
        return this.post(...args);
      case 'delete':
        return this.delete(...args);
      case 'patch':
        return this.patch(...args);
      case 'put':
        return this.put(...args);
      default:
        throw new Error(`Unsupported method: ${method}`);
    }
  }
}

/**
 * axios interceptors runs before and after a request, letting the developer modify req,req more
 * For more details on axios interceptor see https://github.com/axios/axios#interceptors
 */
client.interceptors.request.use((config) => {
  // do something before executing the request
  // For example tag along the bearer access token to request header or set a cookie
  const requestConfig = config;
  // const { headers } = config;
  // requestConfig.headers = { ...headers, Authorization: `Bearer ${getItem('access_token')}` };

  return requestConfig;
});

client.interceptors.response.use(
  (response) => response,
  (error) => {
    /**
     * Do something in case the response returns an error code [3**, 4**, 5**] etc
     * For example, on token expiration retrieve a new access token, retry a failed request etc
     */
    const { response } = error;
    const originalRequest = error.config;

    if ([401].includes(response.status)) {
      const allowedRoutes = [
        /^\/$/, // dla "/"
        /^\/verify\/[^/]+\/[^/]+$/, // dla "verify/:id/:hash"
        /^\/forgotPassword$/, // dla "forgotPassword"
        /^\/register$/, // dla "register"
        /^\/reset-password$/, // dla "reset-password"
        /^\/register\/summary\/[^/]+$/, // dla "register/summary/:uuid"
         /^\/domain-transfer\/confirm\/[^/]+$/, // dla "register/summary/:uuid"
      ];

      const currentPath = window.location.pathname;
      const isAllowedPath = allowedRoutes.some((route) => route.test(currentPath));
      if (!isAllowedPath) {
        window.location.href = '/';
      } else {
        return Promise.reject({
          response: response,
          message: 'Nie jesteś zalogowany, aby uzyskać dostęp do tego zasobu.',
        });
      }
    } else if ([422].includes(response.status)) {
      return Promise.reject({
        errors: response.data.errors,
      });
    } else if ([400].includes(response.status)) {
      return Promise.reject({
        message: response.data.message,
      });
    } else if ([403].includes(response.status)) {
      window.location.href = '/403';
      return Promise.reject({
        message: response.data.message,
      });
    }

    return Promise.reject(response);
  },
);

export { DataService };
